export default "__VITE_ASSET__BLPx3TqR__"